// Clonar no Modelo de Orçamento (Rafael, 15/10) — mesmo comportamento do orçamento (07/10): a cópia
// entra logo abaixo da original e só é gravada ao Salvar. O modelo só guarda o PRODUTO de cada linha
// (grupo e subitem), então o clone é só isso + uma chave nova para a key/arraste.
// O grupo Agência (130 - FEE) e as linhas dele não se clonam: no orçamento ele é único e o FEE /
// Imposto NF Access duplicados virariam cobrança em dobro.
import { AgenciaOrcamentoPolicy } from '../Orcamento/agenciaOrcamentoPolicy';

const copiaProduto = (produto) => (produto ? { ...produto } : null);

export const podeClonarGrupoModelo = (grupo) => !!grupo && !AgenciaOrcamentoPolicy.isGrupoAgencia(grupo);
export const podeClonarSubitemModelo = (grupo, subitem) => !!subitem && podeClonarGrupoModelo(grupo);

export function clonarSubitemModelo(subitem, gerarChave) {
    return { produto: copiaProduto(subitem && subitem.produto), chaveunica: gerarChave() };
}

export function clonarGrupoModelo(grupo, gerarChave) {
    return {
        produto: copiaProduto(grupo && grupo.produto),
        chavegrupo: gerarChave(),
        subitem: ((grupo && grupo.subitem) || []).map((s) => clonarSubitemModelo(s, gerarChave)),
    };
}
